'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = require('react-redux');

var _reduxRouter = require('redux-router');

var _caligramReact = require('caligram-react');

var _querystring = require('querystring');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShowcaseContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    location: state.router.location,
    showcases: state.showcase
  };
}, { push: _reduxRouter.push }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ShowcaseContainer, _Component);

  function ShowcaseContainer() {
    (0, _classCallCheck3.default)(this, ShowcaseContainer);
    return (0, _possibleConstructorReturn3.default)(this, (ShowcaseContainer.__proto__ || (0, _getPrototypeOf2.default)(ShowcaseContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(ShowcaseContainer, [{
    key: 'render',
    value: function render() {
      var events = void 0;
      var eventState = this.props.showcases[(0, _querystring.stringify)((0, _extends3.default)({}, this.props.location.query, this.props.query))];
      if (eventState && eventState.data) {
        events = eventState.data;
      }

      if (!events || !events.length) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'ShowcaseContainer' },
        this.props.children({ title: this.props.title, events: events })
      );
    }
  }]);
  return ShowcaseContainer;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.func,
  location: _react.PropTypes.object,
  showcases: _react.PropTypes.object,
  query: _react.PropTypes.object.isRequired,
  push: _react.PropTypes.func.isRequired,
  title: _react.PropTypes.string
}, _class2.defaultProps = {
  children: function children(props) {
    var dateFormat = function dateFormat(ev) {
      return (0, _moment2.default)(ev.next_date).format('Do MMMM');
    };
    return _react2.default.createElement(_caligramReact.EventList, (0, _extends3.default)({ layout: 'carousel', groupBy: 'none', dateFormat: dateFormat }, props));
  },
  title: 'En vedette'
}, _temp)) || _class);
exports.default = ShowcaseContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ShowcaseContainer.js
// module id = 1102
// module chunks = 0